// O unico caso em que a decisao "o minimo conta embalagens" muda o sentido de um
// numero ja gravado: um produto `UN` COM minimo re-cadastrado como embalagem
// fechada. Nao e migration -- e uma edicao deliberada, e o lugar de avisar e na
// hora de gravar. Avisa, nao trava: minimo e condicao da fabrica, e vender
// diferente e decisao legitima de quem esta na rua.
//
// ⚠ Fala sempre do MAIOR minimo: o mesmo produto pode ter minimos diferentes em
// cada tabela (o codigo 14007 da FORTE PAN vai 20, 400 e 200 nas tres
// condicoes), e avisar pelo menor esconderia o pior caso.
export function avisoDeMinimoAoDefinirFator(
  fator: number | null,
  minimosDosPrecos: readonly number[],
): string | null {
  if (fator === null || fator <= 1 || minimosDosPrecos.length === 0) return null
  const maior = Math.max(...minimosDosPrecos)
  const emUnidades = (maior * fator).toLocaleString('pt-BR', { maximumFractionDigits: 3 })
  const minimo = maior.toLocaleString('pt-BR', { maximumFractionDigits: 3 })
  return (
    `Este produto tem preço com mínimo de ${minimo}. Com embalagem de ${fator} unidades, ` +
    `o mínimo passa a valer ${minimo} embalagens (${emUnidades} unidades). Confira.`
  )
}
